export const ON_LOAD_USER = "ON_LOAD_USER";
export const OPEN_USER_SETTINGS = "OPEN_USER_SETTINGS";
export const CLOSE_USER_SETTINGS = "CLOSE_USER_SETTINGS";
export const SET_USER_SETTINGS_FIELD = "SET_USER_SETTINGS_FIELD";
export const ON_UPDATE_USER_SETTINGS = "ON_UPDATE_USER_SETTINGS";
export const ON_UPDATE_USER_PASSWORD = "ON_UPDATE_USER_PASSWORD";
export const ON_UPDATE_USER_SETTINGS_FAILED = "ON_UPDATE_USER_SETTINGS_FAILED";
export const ON_LOAD_USER_SETTINGS = "ON_LOAD_USER_SETTINGS";
